module.exports = __webpack_public_path__ + "static/media/plus-icon.f4b751e8.svg";